import axios from 'axios';

import {
  loadingStatusShow,
  loadingStatusHide,
} from '../../store/mutations_type';

import store from '../../store';

axios.interceptors.request.use((config) => {
  
  // 取 token 就別再用讀取畫面
  if (config.method === 'post' && 
      config.url.indexOf('token') === -1) {
    store.commit(loadingStatusShow);
  }
  
  return config;

}, (error) => {
  console.log('網路異常');
  return Promise.reject(error);
});

axios.interceptors.response.use((res) => {
  if (res.status !== 200) {
    return Promise.reject(res);
  }

  store.commit(loadingStatusHide);

  return res;

}, (error) => {
  store.commit(loadingStatusHide);
  return Promise.reject(error);

});

export default axios;



// WEBPACK FOOTER //
// ./src/services/config/http.js